import setQueryParamsToString from '../utils/setQueryParamsToString';

const { coreApi } = require('../utils/axios');

const updateOrder = async (orderId, payload = {}) => {
  const response = await coreApi.put(`/orders/${orderId}`, payload);
  return response.data.data;
};

const reportOrRemoveIssue = (orderId, issueFlag) =>
  updateOrder(orderId, {
    issue_reported: !!issueFlag || null,
    notify: false,
  });

const addOrderNotes = (orderId, supportNotes) =>
  updateOrder(orderId, {
    support_notes: supportNotes,
    notify: false,
  });

const cancelOrder = async (orderId) => {
  const response = await coreApi.post(`/orders/support/${orderId}/cancel`);
  return response.data.data;
};

const searchSupportOrder = async (payload) => {
  const { search, ...query } = payload;
  const response = await coreApi.post('/orders/support/dashboard/search' + setQueryParamsToString(query), {
    search: payload.search,
  });
  return { orderIds: response.data.data, pagination: response.data.pagination };
};

const enrichSupportOrders = async ({ types, order_ids }) => {
  const response = await coreApi.post('/orders/support/dashboard/enrich' + setQueryParamsToString(types), {
    order_ids,
  });
  return response.data.data;
};

const orderApi = {
  reportOrRemoveIssue,
  addOrderNotes,
  cancelOrder,
  searchSupportOrder,
  enrichSupportOrders,
};

export default orderApi;
